module.exports = __webpack_public_path__ + "static/media/money-check.791e182f.svg";